import tw from "twin.macro";
import { styled } from "~/config/stitches";

const FieldContent = styled("div", {
  ...tw`mt-1`,
});

export { FieldContent };
